(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cs-color-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cs-color-order')) {
  customElements.define('cs-color-order', class extends HTMLElement {
    static requests = new Map();
    connectedCallback() {
      if (this.initialized) { this.observeWidth(); return; }
      this.initialized = true;
      this.expanded = false;
      this.addEventListener('click', event => {
        const toggle = event.target.closest('[data-color-expand]');
        if (toggle) { this.expanded = !this.expanded; this.showPage(); return; }
        const color = event.target.closest('a[data-cs-color-name]');
        if (!color || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button) return;
        event.preventDefault();
        this.selectCardColor(color);
      });
      this.observeWidth();
      queueMicrotask(() => this.sortColors());
    }
    selectCardColor(color) {
      const card = this.closest('.cs-product');
      if (!card) return;
      const image = card.querySelector('.cs-product-image');
      if (image) image.hidden = !color.dataset.colorImage;
      const missing = card.querySelector('[data-cs-color-missing]');
      if (missing) missing.hidden = !!color.dataset.colorImage;
      if (image && color.dataset.colorImage) {
        image.srcset = color.dataset.colorSrcset || '';
        image.src = color.dataset.colorImage;
        image.alt = color.getAttribute('aria-label');
      }
      const url = new URL(color.href, location.origin);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      card.querySelectorAll('.cs-product-media,.cs-product-title a').forEach(link => { link.href = url; });
      this.querySelectorAll('a[data-cs-color-name]').forEach(node => {
        node.setAttribute('aria-current', String(node === color));
      });
      this.selectedCardColor = color;
      this.paintPrice(card.querySelector('.cs-product-price'), color);
    }
    paintPrice(target, color) {
      if (!target || !color?.dataset.colorPrice) return;
      const price = document.createElement('span');
      price.textContent = color.dataset.colorPrice;
      price.classList.toggle('cs-sale-price', color.dataset.sale === 'true');
      target.replaceChildren(price);
      if (color.dataset.sale === 'true' && color.dataset.colorCompare) {
        const compare = document.createElement('s'); compare.textContent = color.dataset.colorCompare; target.append(compare);
      }
    }
    disconnectedCallback() { this.resizeObserver?.disconnect(); }
    observeWidth() {
      if (!this.dataset.limit) return;
      this.resizeObserver ||= new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (width === this.lastWidth) return;
        this.lastWidth = width;
        this.showPage();
      });
      this.resizeObserver.observe(this);
    }
    showPage() {
      if (!this.colors) return;
      const toggle = this.querySelector('[data-color-expand]');
      if (!toggle) { this.colors.forEach(node => { node.hidden = false; }); return; }
      this.colors.forEach(node => { node.hidden = false; });
      const gap = parseFloat(getComputedStyle(this).columnGap) || 0;
      const width = this.clientWidth;
      const widths = this.colors.map(node => node.getBoundingClientRect().width);
      const totalWidth = widths.reduce((sum, value) => sum + value, 0) + Math.max(0, widths.length - 1) * gap;
      let limit = this.colors.length;
      if (totalWidth > width) {
        toggle.hidden = false;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent = '+' + this.colors.length;
        const reserved = toggle.getBoundingClientRect().width + gap;
        let used = 0;
        limit = 0;
        for (const itemWidth of widths) {
          const needed = itemWidth + (limit ? gap : 0);
          if (used + needed + reserved > width) break;
          used += needed;
          limit++;
        }
      }
      const extra = this.colors.length - limit;
      toggle.hidden = extra === 0;
      toggle.setAttribute('aria-expanded', String(this.expanded));
      toggle.textContent = this.expanded ? toggle.dataset.lessLabel : '+' + extra;
      toggle.setAttribute('aria-label', this.expanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel.replace('[count]', String(extra)));
      this.colors.forEach((node, index) => { node.hidden = !this.expanded && index >= limit; });
    }
    decorateSales() {
      if (this.closest('.cs-product')) return;
      this.querySelectorAll('[data-cs-color-name]').forEach(node => {
        if (node.dataset.sale !== 'true' || node.querySelector('.cs-color-sale-label')) return;
        const label = document.createElement('span'); label.className = 'cs-color-sale-label';
        label.textContent = node.dataset.saleLabel;
        node.append(label);
        node.title = node.dataset.csColorName + ' · ' + node.dataset.saleLabel;
      });
      const detail = this.closest('cs-product-detail');
      if (detail?.dataset.pending === 'true') this.paintPrice(detail.querySelector('.cs-pdp-price'), this.querySelector('[data-cs-color-name]:has(input:checked)'));
    }
    async sortColors() {
      const colors = Array.from(this.children).filter(node => node.hasAttribute('data-cs-color-name'));
      if (!colors.length) return;
      let counts;
      if (Number(this.dataset.variantCount) > 250) {
        try {
          const key = this.dataset.handle + ':' + this.dataset.country;
          if (!this.constructor.requests.has(key)) this.constructor.requests.set(key, this.loadCounts());
          const data = await this.constructor.requests.get(key);
          counts = data.counts;
          const target = this.closest('.cs-product')?.querySelector('[data-cs-available-price]');
          if (target && !this.selectedCardColor && data.summary) {
            const entry = data.summary;
            const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: entry.currency });
            const price = document.createElement('span');
            price.textContent = (entry.min !== entry.max ? target.dataset.fromLabel + ' ' : '') + money.format(entry.min);
            price.classList.toggle('cs-sale-price', entry.compare > entry.min);
            target.replaceChildren(price);
            if (entry.compare > entry.min) {
              const compare = document.createElement('s');
              compare.textContent = money.format(entry.compare);
              target.append(compare);
            }
            const badge = this.closest('.cs-product').querySelector('.cs-promotion__label--sale');
            if (entry.compare <= entry.min) badge?.remove();
          }
          colors.forEach(node => {
            const entry = data.prices.get(node.dataset.csColorName);
            if (!entry) return;
            const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: entry.currency });
            node.dataset.sale = String(entry.sale);
            node.dataset.colorPrice = money.format(entry.min) + (entry.min !== entry.max ? ' – ' + money.format(entry.max) : '');
            node.dataset.colorCompare = entry.sameCompare ? money.format(entry.compare) : '';
          });
        } catch (error) { console.warn('Color availability ordering unavailable', error); }
        if (!this.isConnected) return;
      }
      const ranked = colors.map((node,index) => ({node,index,count:counts ? (counts.get(node.dataset.csColorName) || 0) : Number(node.dataset.csAvailableCount)}));
      ranked.sort((a,b) => b.count-a.count || a.index-b.index);
      const controls = this.querySelector('[data-color-expand]');
      this.colors = [];
      ranked.forEach(({node,count}) => {
        node.dataset.csAvailableCount = String(count);
        node.hidden = count === 0;
        if (count > 0) this.colors.push(node);
        this.insertBefore(node, controls);
      });
      this.hidden = this.colors.length === 0;
      this.showPage();
      this.decorateSales();
      this.dataset.sorted = 'true';
    }
    async loadCounts() {
      const counts = new Map();
      const prices = new Map();
      let summary = null;
      let after = null;
      do {
        const response = await fetch('/api/2026-10/graphql.json', {
          method:'POST', headers:{'Content-Type':'application/json'},
          body:JSON.stringify({query:'query ColorAvailability($handle:String!,$after:String,$country:CountryCode) @inContext(country:$country) { product(handle:$handle) { variants(first:100,after:$after) { nodes { availableForSale price { amount currencyCode } compareAtPrice { amount currencyCode } selectedOptions { name value } } pageInfo { hasNextPage endCursor } } } }',variables:{handle:this.dataset.handle,after,country:this.dataset.country || null}})
        });
        if (!response.ok) throw new Error('Availability request failed');
        const result = await response.json();
        const connection = result.data?.product?.variants;
        if (result.errors || !connection) throw new Error('Availability data missing');
        for (const variant of connection.nodes) {
          if (!variant.availableForSale) continue;
          const priceAmount = Number(variant.price.amount);
          if (!summary) summary = { min: priceAmount, max: priceAmount, compare: Number(variant.compareAtPrice?.amount || 0), currency: variant.price.currencyCode };
          if (priceAmount < summary.min) {
            summary.min = priceAmount;
            summary.compare = Number(variant.compareAtPrice?.amount || 0);
          }
          summary.max = Math.max(summary.max, priceAmount);
          const color = variant.selectedOptions.find(option => /^(color|colour)$/i.test(option.name));
          if (!color) continue;
          if (variant.availableForSale) counts.set(color.value,(counts.get(color.value)||0)+1);
          const amount = Number(variant.price.amount), compare = Number(variant.compareAtPrice?.amount || 0);
          const entry = prices.get(color.value) || { min: amount, max: amount, compare, sameCompare: true, sale: true, currency: variant.price.currencyCode };
          entry.min = Math.min(entry.min, amount); entry.max = Math.max(entry.max, amount);
          entry.sameCompare = entry.sameCompare && entry.compare === compare;
          entry.sale = entry.sale && compare > amount;
          prices.set(color.value, entry);
        }
        after = connection.pageInfo.hasNextPage ? connection.pageInfo.endCursor : null;
      } while (after);
      return { counts, prices, summary };
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
